import React from "react";
import {Container} from "reactstrap";
import {inject, observer} from "mobx-react";
import GenericTableAffichage from "../../../components/Akitatek/Table/GenericTableAffichage";


const Printer = (inject("rootStore")(observer(class Printer extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.injected.rootStore.savedDatasStore.setHeader("Impression", "Gestion des paramètres d'impression", "default.jpg")
    }

    get injected() {
        return this.props;
    }


    render() {
        return (
            <>
                <Container className="mt-2" fluid>
                    <GenericTableAffichage api={this.injected.rootStore.printerStore}
                                           user={false}
                                           filters={this.injected.rootStore.printerStore.defaultFilter}
                                           icon={<i className="fa fa-print mr-2" aria-hidden="true"/>}
                                           name={"Mes impressions"}
                                           type="printers"/>

                    <GenericTableAffichage api={this.injected.rootStore.spoolerStore}
                                           user={false}
                                           filters={this.injected.rootStore.spoolerStore.defaultFilter}
                                           icon={<i className="fa fa-refresh mr-2" aria-hidden="true"/>}
                                           name={"Mon spooler"}
                                           type="spoolers"/>
                </Container>
            </>
        );
    }
})));

export default Printer;
